// @flow
import React, { useEffect, useState } from 'react';
// Components
import Recipe from '../../recipes/components/Recipe';
// Styles
import './MainProductDetails.css';
//Analytics
import * as Analytics from '../../common/analytics';
// Types
import type { Product } from '../types';
import ProductPartImage from './ProductPartImage';
import ProductNutritionalTable from './ProductNutritionalTable';
export type Props = {
  product: Product,
  recipe: any,
  nutritionalValues: any
};

const ProductRecipe = ({ recipes, product }) => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  useEffect(() => {
    Analytics.logTappedShowFullRecipe(
      product,
      window.location.pathname,
      'visit',
    );
    return () => {
      Analytics.logTappedMinimizeRecipe(
        product,
        window.location.pathname,
        'visit',
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const toggleAccordion = (index) => {
    setExpandedIndex(prevIndex => (prevIndex === index ? null : index));
  };

  return (
    <div className="accordion-container">
      {recipes.map((recipe, index) => (
        <div key={index} >
          <button
            onClick={() => toggleAccordion(index)}
            className="accordion-toggle"
          >
            <div class={index == expandedIndex ? 'accordion-item-title-selected' : 'accordion-item-title'}>{recipe.title || `Receita ${index + 1}`}</div>
            <i
              className="fa fa-caret-down fa-1x"
              aria-hidden="true"
            />
          </button>
          <div
            className={`accordion-content ${expandedIndex === index ? 'expanded' : ''}`}
          >
            <Recipe recipe={recipe} />
          </div>
        </div>
      ))}
    </div>
  );
};



const MainProductDetails = ({ product, recipes, nutritionalValues }: Props) => {
  return (
    <div className="main-product-details-main">
      <div>
        <h5 className="main-product-details-title-item">Descrição do Produto</h5>
        {(product.htmlDescription && product.htmlDescription.body) ? (
          <div dangerouslySetInnerHTML={{ __html: product.htmlDescription.body }} />
        ) : (
          <>{product.description}</>
        )}

        {product && recipes && recipes.length > 0 && (
          <>
            <h5 className="main-product-details-title-item">Receitas e Dicas</h5>
            <ProductRecipe product={product} recipes={recipes} />
          </>
        )}

        <div className="main-product-details-more-info-container">
          {nutritionalValues?.nutritionValues && nutritionalValues.nutritionValues.length > 0 && <ProductNutritionalTable product={product} nutritionalValues={nutritionalValues} />}
          <ProductPartImage product={product} />
        </div>
      </div>
    </div>
  );
};

export default MainProductDetails;
